<app-navigation class="pcoded-navbar" [ngClass]="{'navbar-collapsed' : navCollapsed, 'theme-horizontal': this.nextConfig['layout'] === 'horizontal', 'mob-open' : navCollapsedMob}" (onNavMobCollapse)="navMobClick()"></app-navigation>
<app-nav-bar class="navbar pcoded-header navbar-expand-lg navbar-light ps-3 pb-2 pt-2 pe-3 navbar-tablet-height" (onNavCollapse)="this.navCollapsed = !this.navCollapsed;" (onNavHeaderMobCollapse)="navMobClick()" (onNavToggleChat)="navToggleChat()"></app-nav-bar>
<app-custom-chat [hidden]="hideChat || !onlineOfflineService.isOnline" (onNavToggleChat)="navToggleChat()"></app-custom-chat>
<div class="pcoded-main-container" [style.margin-right]="hideChat || !onlineOfflineService.isOnline ? '0px' : '500px'">
  <div class="pcoded-wrapper" [ngClass]="{'container': this.nextConfig.layout === 'horizontal' && this.nextConfig.subLayout === 'horizontal-2'}">
    <div class="pcoded-content">
      <div class="pcoded-inner-content">
        <div class="main-body">
          <div class="page-wrapper">
            <app-loader></app-loader>
            <br />
            <div id="offlineModulo" *ngIf="!onlineOfflineService.isOnline">
              <p id="offline" class="message warn">Please be informed that you are currently working offline. Once you click on the WIFI button or as soon as you get internet again, you will have to re-login to submit the transaction.</p>
            </div>
            <div class="popup mb-5" id="divCustomLogin" *ngIf="onlineOfflineService.isOnline && !onlineOfflineService.isAuthenticated && countOfflineTransaction == 0 && !isResyncing">
              <a (click)="open(customLogin)">You are currently logged in as an unauthenticated user. Please <u>click here</u> to authenticate/login.</a>
              <ng-template #customLogin let-modal>
                <app-custom-login></app-custom-login>
              </ng-template>
            </div>

            <div class="popup mb-5" *ngIf="onlineOfflineService.isOnline && countOfflineTransaction > 0 && !isResyncing">
              <a (click)="open(customLogin)">You have pending offline transaction and will be submitted after you login. Please <u>click here</u> to login.</a>
              <ng-template #customLogin let-modal>
                <app-custom-login></app-custom-login>
              </ng-template>
            </div>

            <div class="pb-4" *ngIf="onlineOfflineService.isOnline && isResyncing">
              <div class="spinner-border spinner-border-sm" role="status"></div><span class="h6 px-3">Processing offline transaction... Please wait.</span>
            </div>

            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-configuration></app-configuration>
